var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "calc(100vh - 261px)"
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh",
      "z-index": "999",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "position": "fixed",
      "left": "0",
      "top": "0",
      "background-color": "rgba(255, 255, 255, 0.8)"
    }
  }, [_c('Spin')], 1) : _vm._e(), _vm._v(" "), (_vm.gengxinrizhiModal.displayed) ? [_c('Drawer', {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "placement": "right",
      "width": "440",
      "closable": false,
      "scrollable": false
    },
    on: {
      "on-visible-change": _vm.gengxinrizhiModal.displayChanged
    },
    model: {
      value: (_vm.gengxinrizhiModal.display),
      callback: function($$v) {
        _vm.$set(_vm.gengxinrizhiModal, "display", $$v)
      },
      expression: "gengxinrizhiModal.display"
    }
  }, [_c('Updatelog', {
    ref: "updatelogref",
    attrs: {
      "current": _vm.gengxinrizhiModal.current
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isDocsRoute) ? [_c('router-view')] : [_c('div', {
    staticStyle: {
      "height": "60px",
      "width": "100%",
      "z-index": "9",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "background-color": "#fff",
      "border-bottom": "1px solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "line-height": "60px",
      "padding-left": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px",
      "margin-right": "12px"
    },
    attrs: {
      "src": "//cdn.igyl.com/vendor-statics/k.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("供应链 · " + _vm._s((_vm.session && _vm.session.jigou) ? '智能版' : '总后台'))]), _vm._v(" "), _c('div', {
    staticClass: "admintag center",
    staticStyle: {
      "background-color": "#f5f5f5",
      "border-radius": "16px",
      "margin-left": "20px",
      "padding": "4px 8px",
      "height": "30px",
      "color": "#333"
    },
    on: {
      "click": _vm.gengxinrizhiModal.show
    }
  }, [(_vm.session) ? _c('Badge', {
    attrs: {
      "dot": _vm.newversiontip,
      "offset": [20, -6]
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-list-box"
    }
  }), _vm._v(" " + _vm._s(_vm.localcv || '1.0.0') + "\n                ")], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.session && _vm.session.zhanghao) ? _c('div', {
    staticStyle: {
      "padding-right": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.session.sysadmin) ? _c('div', {
    staticClass: "admintag"
  }, [_vm._v("超级管理员：" + _vm._s(_vm.session.sysadmin))]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    },
    on: {
      "on-visible-change": _vm.loadZhanghaos
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-right": "20px"
    },
    attrs: {
      "id": "current_jigou"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.session.jigou ? _vm.session.jigou.name : '总后台'))])]), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#aaa",
      "padding-top": "10px"
    }
  }, [_vm._v("切换身份")]), _vm._v(" "), (_vm.session.sysadmin) ? _c('div', {
    staticStyle: {
      "padding": "7px 16px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "更换到手机号",
      "search": ""
    },
    on: {
      "on-enter": _vm.loadZhanghaos
    },
    model: {
      value: (_vm.sysadminphone),
      callback: function($$v) {
        _vm.sysadminphone = $$v
      },
      expression: "sysadminphone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "7px 16px"
    },
    attrs: {
      "id": "account_search_wapper"
    }
  }, [_c('Input', {
    ref: "account_search",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "搜索",
      "search": ""
    },
    on: {
      "input": _vm.shopInput
    },
    model: {
      value: (_vm.shopsName),
      callback: function($$v) {
        _vm.shopsName = $$v
      },
      expression: "shopsName"
    }
  })], 1), _vm._v(" "), (_vm.accounts.length >= 1) ? _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.accounts), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.toSwitch(item)
        }
      }
    }, [(item._id != _vm.session.zhanghao._id && item.actived && !item.deleted && (!item.jituan || item.jituan.actived !== false) && (!item.jigou || (item.jigou.actived === undefined || item.jigou.actived))) ? _c('DropdownItem', {
      key: index
    }, [_c('div', [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "max-width": "300px"
      }
    }, [_vm._v(_vm._s(item.jigou ? item.jigou.name : '总后台'))]), _vm._v(" "), (item.jueses && item.jueses[0]) ? _c('div', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v(_vm._s(item.jueses.map(function (i) {
      return i.name
    }).join(',')))]) : _vm._e(), _vm._v(" "), (_vm.session.sysadmin) ? _c('div', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.user ? item.user.phone : '') + ")")]) : _vm._e()])]) : _vm._e()], 1)
  }), 0) : _c('div', {
    staticStyle: {
      "padding": "16px",
      "text-align": "center"
    }
  }, [_vm._v("\n                        暂无数据\n                    ")])])], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "id": "current_account"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.session.zhanghao.name) + "\n                    "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.session.jigou) ? _c('DropdownItem', [_c('div', {
    on: {
      "click": _vm.toProfile
    }
  }, [_vm._v("\n                            个人中心\n                        ")])]) : _vm._e(), _vm._v(" "), _c('DropdownItem', [_c('div', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                            退出\n                        ")])])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.session && _vm.session.zhanghao) ? _c('div', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "height": "calc(100vh - 60px)",
      "overflow-y": "scroll"
    }
  }, [_c('Menu', {
    ref: "menus",
    staticStyle: {
      "min-height": "calc(100vh - 60px)"
    },
    attrs: {
      "active-name": _vm.active_menu,
      "theme": "light",
      "width": "auto",
      "open-names": _vm.active_menugroup,
      "accordion": ""
    },
    on: {
      "on-select": _vm.mendSelect
    }
  }, [_c('Menu-item', {
    staticClass: "menu-item",
    attrs: {
      "name": "0",
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-grid-outline",
      "size": "16"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._l((_vm.session.menuGroups), function(item, index) {
    return _c('Submenu', {
      key: index,
      attrs: {
        "name": item.key
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-grid-outline",
        "size": "16"
      }
    }), _vm._v(" "), (_vm.groupbadge) ? _c('Badge', {
      attrs: {
        "count": _vm.groupbadge[item.code],
        "overflow-count": "99"
      }
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _vm._l((item.menus), function(menu, index) {
      return _c('Menu-item', {
        key: index,
        staticClass: "menu-item",
        staticStyle: {
          "background-color": "#fafafa",
          "margin-left": "16px"
        },
        attrs: {
          "to": menu.path,
          "name": menu.key
        }
      }, [(_vm.session.badge) ? _c('Badge', {
        attrs: {
          "count": _vm.session.badge[item.code] ? _vm.session.badge[item.code][menu.code] : 0,
          "overflow-count": "99"
        }
      }, [_c('span', [_vm._v(_vm._s(menu.name))])]) : _c('span', [_vm._v(_vm._s(menu.name))])], 1)
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100vw - 200px)",
      "height": "calc(100vh - 60px)",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app-nav",
    staticStyle: {
      "height": "40px",
      "position": "fixed",
      "background": "#fff",
      "top": "60px",
      "left": "200px",
      "width": "calc(100vw - 216px)",
      "z-index": "99"
    }
  }, [_c('tags-nav', {
    attrs: {
      "value": _vm.$route,
      "list": _vm.tagNavList
    },
    on: {
      "input": _vm.handleClick,
      "on-close": _vm.handleCloseTag
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-nav-padding",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "exclude": _vm.excludeCache,
      "max": 15
    }
  }, [_c('router-view', {
    ref: "main",
    attrs: {
      "activeMenu": _vm.active_menu
    }
  })], 1)], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.session && !_vm.session.zhanghao) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#fff",
      "border": "1px solid rgb(241, 241, 241)",
      "min-height": "392px",
      "width": "415px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f7f8fa",
      "font-weight": "bold",
      "padding": "10px",
      "font-size": "20px"
    }
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "hover",
    style: ('width:50%;padding: 10px 0;' + (_vm.form.type == 'scan' ? 'border-bottom:4px solid #20bf64;font-weight:bold;' : 'border-bottom:1px solid #f1f1f1')),
    on: {
      "click": function($event) {
        _vm.form.type = 'scan';
        _vm.loadLoginCode()
      }
    }
  }, [_vm._v("扫码登录")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    style: ('width:50%;padding: 10px 0;' + (_vm.form.type == 'phone' ? 'border-bottom:4px solid #20bf64;font-weight:bold;' : 'border-bottom:1px solid #f1f1f1')),
    on: {
      "click": function($event) {
        _vm.form.type = 'phone'
      }
    }
  }, [_vm._v("手机登录")])]), _vm._v(" "), (_vm.form.type == 'phone') ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px",
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.logining,
      "disabled": !!(!_vm.form.phone || _vm.codeCD)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeCD ? ('重新获取（' + _vm.codeCD + '）') : '获取验证码'))])], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "380px",
      "margin-top": "40px",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.logining,
      "disabled": !_vm.codeSend
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.type == 'scan') ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(!_vm.scanSuccess) ? _c('div', [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.loginCode) ? _c('img', {
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": _vm.loginCode.url
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.loginCode) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("请使用微信扫码")]) : _vm._e(), _vm._v(" "), (!_vm.loginCode) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("正在加载二维码")]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#20bf64",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-checkmark-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("已完成扫码")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.resetQrcode
    }
  }, [_vm._v("重新获取")])], 1)]) : _vm._e()]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": 750
    },
    model: {
      value: (_vm.profileModal),
      callback: function($$v) {
        _vm.profileModal = $$v
      },
      expression: "profileModal"
    }
  }, [(_vm.profileModal) ? _c('ProfileForm', {
    ref: "profileForm",
    on: {
      "cancel": function($event) {
        _vm.profileModal = false;
      },
      "dataChanged": function($event) {
        _vm.profileModal = false;
      }
    }
  }) : _vm._e()], 1)]], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('p'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8d8d8d",
      "margin": "0 0 5px 0"
    }
  }, [_vm._v("Copyright © 2020-2030 All rights reserved.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8d8d8d",
      "text-decoration": "none",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("浙ICP备18054766号")]), _vm._v(" "), _c('p')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daf97d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = RhhK
// module chunks = 138